(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[778],{

/***/ "aSLe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Insurance", function() { return Insurance; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Insurance = function Insurance(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    "aria-hidden": "true",
    focusable: "false",
    viewBox: "0 0 500 500"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    d: "M308 128L185 257l-57-54-21 19 80 75 142-150-21-19zm81 107c-19 38-49 87-78 129-38 55-74 94-103 108h0-1c-29-14-65-53-103-108-29-42-58-91-78-129h0V70a417 417 0 01182-45 417 417 0 01181 45v165h0zm20-182a106 106 0 00-15-8l-39-18C314 12 266 2 213 1h0-3s0 0 0 0a101 101 0 01-5 0s0 0 0 0h-2 0-1A434 434 0 006 53l-5 4v184l1 3a533 533 0 0021 39c16 27 32 54 50 80 49 73 95 122 134 136h0s0 0 0 0h1s0 0 0 0h0c39-14 86-63 134-136a1262 1262 0 0071-119l2-3V57l-6-4z"
  }));
};

/***/ })

}]);